import React, { useEffect, useState } from 'react';
import Header from '../Layout/Header';
import "./css/roster.css"
import moment from 'moment';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import Sidebar from '../Layout/Sidebar';
import CustomHeader from '../Layout/Header';
import { Layout } from "antd";
import { connect } from 'react-redux';
import {
  getFilterData,
  getCompanySeatData,
  postSeatBookingData,
  postSeatBookingDataNew,
  getRosterBookingData,
  getDepartmentUserData,
  getDepartmentList,
  postAutoAssign,
  resetUser,
} from '../../Redux/action/rosterAction';
import { dataUser, removeDuplicateObjectFromArray } from '../Helpers/util';
import MarketingPanel from '../MarketingPanel';
import { getServiceAccess } from '../../Redux/action/userActions';

import { toast } from 'react-toastify';
import { data } from 'jquery';
import axios from 'axios';
import DualListBox from 'react-dual-listbox';
import mixpanel from 'mixpanel-browser';
import Select from 'react-select';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";
import SwCheckbox from '../Common/FormComponent/SwCheckbox';
import SwButton from '../Common/SwButtons/SwButtons';
import SwLoader from '../Common/SwLoader/SwLoader';
import SwModal from '../Common/SwModal/SwModal';

// var selectedUserListArr = [];

function Roster({
  rosterData: {
    shiftStartData: { data: shiftStartData, loading: shiftStartDataLoading },
    shiftEndData: { data: shiftEndData, loading: shiftEndDataLoading },
    userData: { data: userData, loading: userDataLoading },
    seatData: { data: seatData, loading: seatDataLoading },
    rosterBooking: { data: rosterBookingData, loading: rosterDataLoading },
    departmentList: { data: departmentList, loading: departmentListLoading },
    seatBooking: { loading: seatBookingLoading },
    availableSeatData: {
      data: availableSeatData,
      loading: availableSeatDataLoading,
    },
    assignSeat: { data: assignSeat, loading: assignSeatLoading },
    resetUsers: { data: resetUserData },
  },

  getDepartmentUserData,
  getRosterBookingData,
  postSeatBookingData,
  postSeatBookingDataNew,
  getCompanySeatData,
  getDepartmentList,
  getFilterData,
  postAutoAssign,
  resetUser,
}) {
  const [departmentOption, setDepartmentOption] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [currentSelectedDepartment, setCurrentSelectedDepartment] = useState(null);
  const [currentSelectedLocation, setCurrentSelectedLocation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [tableContent, setTableContent] = useState([]);
  const [filterContent, setFilterContent] = useState([]);
  const [deployShiftStart, setDeployShiftStart] = useState(null);
  const [deployShiftEnd, setDeployShiftEnd] = useState(null);
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [fromSeatId, setFromSeatId] = useState(null);
  const [locationOption, setLocationOption] = useState([]);
  const [departmentSeat, setDepartmentSeat] = useState([]);
  const [accessServiceLists, setAccessServiceLists] = useState([]);
  const [loaderServiceAccess, setLoaderServiceAccess] = useState(true);
  const [weekOff, setWeekOff] = useState([
    { day: 'Sun', value: true },
    { day: 'Mon', value: false },
    { day: 'Tue', value: false },
    { day: 'Wed', value: false },
    { day: 'Thu', value: false },
    { day: 'Fri', value: false },
    { day: 'Sat', value: true },
  ]);
  const [selectedUserList, setSelectedUserList] = useState([]);
  const [bool2, setBool2] = useState(true);
  const options = [];
  let resetTime = false;

  userData.map(items => {
    options.push({
      value: items.rec_id,
      label: items.name,
    });
  });




  const toggleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };

  if (options.length > 0) {
    options.sort((a, b) =>
      a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1,
    );
  }

  if (departmentOption.length > 0) {
    departmentOption.sort((a, b) =>
      a.dept_name.toLowerCase() < b.dept_name.toLowerCase() ? -1 : 1,
    );
  }

  locationOption.sort((a, b) =>
    a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1,
  );

  const todayBookingAccessUserEmail = [
    'Srinivas.Raghavendra@onitygroup.com',
    'archana.harwalkar@onitygroup.com',
    'debabrata.burman@onitygroup.com',
    'antonio.aquino@onitygroup.com',
    'manasvi.malav@sworks.co.in',
    'gokul.rajasekar@sworks.co.in',
    'kamran.ahmad@sworks.co.in',
  ].map(v => v.toLowerCase());

  const [startDate, setStartDate] = useState(
    moment()
      .add(1, 'days')
      .format('YYYY-MM-DD'),
  );
  var end_date = moment(moment(startDate, 'YYYY-MM-DD').add(1, 'M')).format(
    'YYYY-MM-DD',
  );
  const [endDate, setEndDate] = useState(end_date);

  const userDataLocal = dataUser();
  var UserObj = JSON.parse(userDataLocal);

  const [copyStartDate, setCopyStartDate] = useState(
    moment(moment(end_date, 'YYYY-MM-DD').add(1, 'days')).format('YYYY-MM-DD'),
  );

  const [copyEndDate, setCopyEndDate] = useState(
    moment(moment(copyStartDate, 'YYYY-MM-DD').add(5, 'days')).format(
      'YYYY-MM-DD',
    ),
  );

  const onUserListChange = selected => {
    // selectedUserListArr = [];
    // selectedUserListArr = selected;
    setSelectedUserList(selected);

    // let sortedFilterData = [];

    // const filterContentData = tableContent.filter(
    //   item => selectedUserListArr.includes(item.userId),
    // );

    // selectedUserListArr.forEach(userId => {
    //   let index = filterContentData.findIndex(item => item.userId == userId)
    //   sortedFilterData.push(filterContentData[index]);
    // });

    // //set content
    // setFilterContent(sortedFilterData);

    //set content
    // setTableContent(tableContent);
  };

  useEffect(() => {
    fetchServiceAccess();
  }, []);

  const fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    setAccessServiceLists(response);
    setLoaderServiceAccess(false);
  };

  // useEffect(() => {
  //   getDepartmentList(UserObj.company_id, UserObj.rec_id);
  // }, []);

  useEffect(() => {
    let tableCol = [];
    let sortedUser = [];

    //Filter user by selected user list
    userData = userData.filter(item => selectedUserList.includes(item.rec_id));

    selectedUserList.forEach(userId => {
      let index = userData.findIndex(item => item.rec_id == userId);
      sortedUser.push(userData[index]);
    });
    userData = sortedUser;
    for (let j = 0; j < userData.length; j++) {
      tableCol.push({
        userId: userData[j].rec_id,
        spoc_id: UserObj.rec_id,
        userName: userData[j].name,
        userEmail: userData[j].email,
        seatId: null,
        spoc_email: UserObj.email,
        spoc_name: UserObj.fname + ' ' + UserObj.lname,
        dateArray: [],
      });
      const dateArr = [];
      for (
        let i = moment(startDate);
        moment(i).isSameOrBefore(endDate);
        i = i.add(1, 'd')
      ) {
        dateArr.push({
          date: i.format('YYYY-MM-DD').toString(),
          shiftStart: weekOff[moment(i).day()].value ? -1 : null,
          shiftEnd: weekOff[moment(i).day()].value ? -1 : null,
          isdisabled: true, //moment(i).isSameOrBefore(moment()),
          createdRoster: false,
        });
      }
      tableCol[j].dateArray = dateArr;
    }

    const updatedRosterBooking = [...tableCol];
    if (rosterBookingData.length > 0 && tableCol.length > 0) {
      for (var i = 0; i < rosterBookingData.length; i++) {
        const isPresent = updatedRosterBooking.findIndex(
          selected => selected.userId === rosterBookingData[i].user_id,
        );
        if (isPresent === -1) {
          updatedRosterBooking.push({
            userId: rosterBookingData[i].user_id,
            spoc_id: UserObj.rec_id,
            userName: rosterBookingData[i].username,
            seatId: rosterBookingData[i].seat_id,
            dateArray: rosterBookingData[i].dateArray.map(date => ({
              ...date,
              shiftStart: date.shift_start_id,
              shiftEnd: date.shift_end_id,
              seatId: rosterBookingData[i].seat_id,
              date: date.shift_date,
              shift_start_time: date.shift_start_time,
              shift_end_time: date.shift_end_time,
              createdRoster: true,
            })),
          });
        } else {
          updatedRosterBooking[isPresent].seatId = rosterBookingData[i].seat_id;

          for (
            let k = 0;
            k < updatedRosterBooking[isPresent].dateArray.length;
            k++
          ) {
            for (let j = 0; j < rosterBookingData[i].dateArray.length; j++) {
              if (
                moment(rosterBookingData[i].dateArray[j].shift_date).isSame(
                  moment(updatedRosterBooking[isPresent].dateArray[k].date),
                )
              ) {
                updatedRosterBooking[isPresent].dateArray[k].shiftStart =
                  rosterBookingData[i].dateArray[j].shift_start_id;
                updatedRosterBooking[isPresent].dateArray[k].shiftEnd =
                  rosterBookingData[i].dateArray[j].shift_end_id;
                updatedRosterBooking[isPresent].dateArray[k].shift_start_time =
                  rosterBookingData[i].dateArray[j].shift_start_time;
                updatedRosterBooking[isPresent].dateArray[k].shift_end_time =
                  rosterBookingData[i].dateArray[j].shift_end_time;
                updatedRosterBooking[isPresent].dateArray[k].seatId =
                  rosterBookingData[i].dateArray[j].seat_id;
                updatedRosterBooking[isPresent].dateArray[
                  k
                ].seat_title = getTitle(
                  rosterBookingData[i].dateArray[j].seat_id,
                );
                updatedRosterBooking[isPresent].dateArray[
                  k
                ].createdRoster = true;
                updatedRosterBooking[isPresent].dateArray[k].isdisabled = true;
              }
            }
          }
        }
      }
    }

    setTableContent([...updatedRosterBooking]);
  }, [rosterBookingData, userData, startDate, endDate]);

  const getTitle = seatID => {
    let titleObj = departmentSeat.find(element => element.seat_id == seatID);
    return titleObj && titleObj.name ? titleObj.name : '';
  };

  useEffect(() => {
    if (departmentList.length > 0) {
      setDepartmentOption(
        departmentList.map(department => ({
          id: department.id,
          name: department.dept_name,
        })),
      );
      // const UniqLocationArray = removeDuplicateObjectFromArray(
      //   departmentList.reduce(
      //     (locationArr, department) => [
      //       ...locationArr,
      //       ...department.locationArr,
      //     ],
      //     [],
      //   ),
      //   'location_id',
      // );
      // setLocationOption(UniqLocationArray);
    }
  }, [departmentList]);

  useEffect(() => {
    // btnClick();
  });

  useEffect(() => {
    if (selectedDepartment) {
      let UniqLocationArray;
      for (let i = 0; i < departmentList.length; i++) {
        if (departmentList[i].id == selectedDepartment) {
          UniqLocationArray = departmentList[i].locationArr;
        }
      }
      if (UniqLocationArray && UniqLocationArray.length > 0) {
        setLocationOption(UniqLocationArray);
      }
    }
  }, [selectedDepartment]);

  useEffect(() => {
    if (
      selectedUser.length === tableContent.length &&
      selectedUser.length != 0
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedUser]);

  useEffect(() => {
    if (seatData.length > 0) {
      const ids = seatData.map(o => o.seat_id);

      seatData = seatData.filter(
        ({ seat_id }, index) => !ids.includes(seat_id, index + 1),
      );

      seatData = seatData.sort((a, b) => {
        return a.seat_id - b.seat_id;
      });
    }
    setDepartmentSeat(seatData);
  }, [seatData]);

  function onDepartmentSubmit(startDt, endaDt) {
    mixpanel.track('Roster View', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'View',
    });
    const startDateString = moment(startDt)
      .format('YYYY-MM-DD')
      .toString();
    const endDateString = moment(endaDt)
      .format('YYYY-MM-DD')
      .toString();
    // let userIds = [14573, 16188];
    // getRosterBookingData(
    //   UserObj.company_id,
    //   selectedDepartment,
    //   selectedLocation,
    //   endDateString,
    //   startDateString,
    //   userIds
    // );
    getFilterData(UserObj.company_id, selectedDepartment, 'start_time');
    getFilterData(UserObj.company_id, selectedDepartment, 'end_time');
    getDepartmentUserData(
      UserObj.company_id,
      selectedDepartment,
      selectedLocation,
    );
    getCompanySeatData(selectedDepartment, selectedLocation);
    setBool2(true);
  }

  const CloseToastButton = ({ closeToast }) => (
    <i className="material-icons" onClick={closeToast}>
      <i className="bi bi-x-lg" />
    </i>
  );

  function onStartDateChange(e) {
    var end_date = moment(
      moment(e.target.value, 'YYYY-MM-DD').add(1, 'M'),
    ).format('YYYY-MM-DD');
    setStartDate(e.target.value);
    setEndDate(end_date);
    setCopyStartDate(
      moment(moment(end_date, 'YYYY-MM-DD').add(1, 'days')).format(
        'YYYY-MM-DD',
      ),
    );

    setCopyEndDate(
      moment(moment(end_date, 'YYYY-MM-DD').add(6, 'days')).format(
        'YYYY-MM-DD',
      ),
    );
  }

  function onEndDateChange(e) {
    var startDate2 = moment(startDate, 'YYYY-MM-DD');
    var endDate = moment(e.target.value, 'YYYY-MM-DD');
    var result = endDate.diff(startDate2, 'days');
    if (result >= 0) {
      setEndDate(e.target.value);
      setCopyStartDate(
        moment(moment(endDate, 'YYYY-MM-DD').add(1, 'days')).format(
          'YYYY-MM-DD',
        ),
      );
      setCopyEndDate(
        moment(moment(endDate, 'YYYY-MM-DD').add(6, 'days')).format(
          'YYYY-MM-DD',
        ),
      );
    } else {
      toast.error('End date cannot be less than start date', {

        // autoClose: false,
        // closeButton: CloseToastButton,
      });
    }
  }

  function copyStartDate2(e) {
    var end_date = moment(
      moment(e.target.value, 'YYYY-MM-DD').add(5, 'days'),
    ).format('YYYY-MM-DD');
    setCopyStartDate(e.target.value);
    setCopyEndDate(end_date);
  }

  function copyEndDate2(e) {
    var startDate2 = moment(copyStartDate, 'YYYY-MM-DD');
    var endDate = moment(e.target.value, 'YYYY-MM-DD');
    var result = endDate.diff(startDate2, 'days');
    if (result >= 0) {
      setCopyEndDate(e.target.value);
    } else {
      toast.error('End date cannot be less than start date', {

        // autoClose: false,
        // closeButton: CloseToastButton,
      });
    }
  }

  function loopDate() {
    let dateCol = [];

    for (
      let i = moment(startDate);
      moment(i).isSameOrBefore(endDate);
      i = i.add(1, 'd')
    ) {
      dateCol.push(<th>{i.format('ddd DD MMM').toString()}</th>);
    }
    return dateCol;
  }

  // function createShiftOption(shiftArr) {
  //   const data = shiftArr.sort(function(a, b) {
  //     return a.shift_id - b.shift_id;
  //   });
  //   return data.map(shift => {
  //     return <option value={shift.shift_id}>{shift.shift_time}</option>;
  //   });
  // }
  function createShiftOption(shiftArr, isTwentyfourGap, date) {
    // sorting
    const data = shiftArr.sort(function (a, b) {
      return a.shift_id - b.shift_id;
    });
    return data.map(shift => {
      const today = moment().format('YYYY-MM-DD');
      let shiftTime = `${today} ${shift.shift_time}`;

      if (
        date &&
        moment(date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
      ) {
        if (shiftTime > moment(new Date()).format('YYYY-MM-DD HH:mm:ss'))
          return <option value={shift.shift_id}>{shift.shift_time}</option>;
        else {
          return (
            <option disabled value={shift.shift_id}>
              {shift.shift_time}
            </option>
          );
        }
      } else if (
        date &&
        moment(date).format('YYYY-MM-DD') ===
        moment()
          .add(1, 'days')
          .format('YYYY-MM-DD') &&
        isTwentyfourGap
      ) {
        const nextDay = moment()
          .add(1, 'days')
          .format('YYYY-MM-DD');
        let shiftTime = `${nextDay} ${shift.shift_time}`;
        if (
          shiftTime >
          moment(new Date())
            .add(moment.duration(24, 'hours'))
            .format('YYYY-MM-DD HH:mm:ss')
        )
          return <option value={shift.shift_id}>{shift.shift_time}</option>;
        else {
          return (
            <option disabled value={shift.shift_id}>
              {shift.shift_time}
            </option>
          );
        }
      } else return <option value={shift.shift_id}>{shift.shift_time}</option>;
    });
  }

  function onWeekOffChange(day) {
    const updatedWeekOff = weekOff.map(item => {
      if (item.day === day) {
        return { ...item, value: !item.value };
      }
      return item;
    });

    setWeekOff(updatedWeekOff);
  }

  function onDeployShiftApply() {
    let isTodayAccess = todayBookingAccessUserEmail.includes(UserObj.email?.toLowerCase())
      ? true
      : false;
    let todayDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
    let todayDateTimeUnix = moment(todayDateTime).unix();
    const updated = [];

    for (let i = 0; i < tableContent.length; i++) {
      const dateArr = [];
      for (let j = 0; j < tableContent[i].dateArray.length; j++) {
        let deployTimeObj = shiftStartData.find(
          item => item.shift_id == deployShiftStart,
        );
        let deployShiftDateTime = `${tableContent[i].dateArray[j].date} ${deployTimeObj.shift_time
          }`;
        let deployShiftDateTimeUnix = moment(deployShiftDateTime).unix();
        let diffInHours = getTimeDiff(
          todayDateTimeUnix,
          deployShiftDateTimeUnix,
          'hours',
        );
        if (!isTodayAccess && diffInHours <= 24) {
          dateArr.push({
            ...tableContent[i].dateArray[j],
            shiftStart: '',
            shiftEnd: '',
          });
        } else {
          if (
            tableContent[i].dateArray[j].shiftStart == null ||
            tableContent[i].dateArray[j].shiftEnd == null
          ) {
            var date = moment(tableContent[i].dateArray[j].date);
            var now = moment();
            if (date > now) {
              var shiftStartVariable;
              var shiftEndVariable;
              if (tableContent[i].dateArray[j].createdRoster) {
                if (
                  weekOff[moment(tableContent[i].dateArray[j].date).day()].value
                ) {
                  shiftStartVariable = -1;
                  shiftEndVariable = -1;
                } else {
                  shiftStartVariable = deployShiftStart;
                  shiftEndVariable = deployShiftEnd;
                }
              } else if (
                weekOff[moment(tableContent[i].dateArray[j].date).day()].value
              ) {
                shiftStartVariable = -1;
                shiftEndVariable = -1;
              } else {
                shiftStartVariable = deployShiftStart;
                shiftEndVariable = deployShiftEnd;
              }
              dateArr.push({
                ...tableContent[i].dateArray[j],
                shiftStart: shiftStartVariable,
                shiftEnd: shiftEndVariable,
              });
            } else {
              dateArr.push({
                ...tableContent[i].dateArray[j],
                shiftStart: tableContent[i].dateArray[j].createdRoster
                  ? tableContent[i].dateArray[j].shiftStart
                  : weekOff[moment(tableContent[i].dateArray[j].date).day()]
                    .value
                    ? -1
                    : tableContent[i].dateArray[j].shiftStart,
                shiftEnd: tableContent[i].dateArray[j].createdRoster
                  ? tableContent[i].dateArray[j].shiftEnd
                  : weekOff[moment(tableContent[i].dateArray[j].date).day()]
                    .value
                    ? -1
                    : tableContent[i].dateArray[j].shiftEnd,
              });
            }
          } else {
            var date = moment(tableContent[i].dateArray[j].date);
            var now = moment();
            if (date > now) {
              var shiftStartVariable;
              var shiftEndVariable;
              if (tableContent[i].dateArray[j].createdRoster) {
                if (
                  weekOff[moment(tableContent[i].dateArray[j].date).day()].value
                ) {
                  shiftStartVariable = -1;
                  shiftEndVariable = -1;
                } else {
                  shiftStartVariable = tableContent[i].dateArray[j].shiftStart;
                  shiftEndVariable = tableContent[i].dateArray[j].shiftEnd;
                }
              } else if (
                weekOff[moment(tableContent[i].dateArray[j].date).day()].value
              ) {
                shiftStartVariable = -1;
                shiftEndVariable = -1;
              } else {
                //for future use
                // shiftStartVariable = tableContent[i].dateArray[j].shiftStart;
                // shiftEndVariable = tableContent[i].dateArray[j].shiftEnd;
                shiftStartVariable = deployShiftStart;
                shiftEndVariable = deployShiftEnd;
              }
              dateArr.push({
                ...tableContent[i].dateArray[j],
                shiftStart: shiftStartVariable,
                shiftEnd: shiftEndVariable,
              });
            } else {
              dateArr.push({
                ...tableContent[i].dateArray[j],
                shiftStart: tableContent[i].dateArray[j].createdRoster
                  ? tableContent[i].dateArray[j].shiftStart
                  : weekOff[moment(tableContent[i].dateArray[j].date).day()]
                    .value
                    ? -1
                    : tableContent[i].dateArray[j].shiftStart,
                shiftEnd: tableContent[i].dateArray[j].createdRoster
                  ? tableContent[i].dateArray[j].shiftEnd
                  : weekOff[moment(tableContent[i].dateArray[j].date).day()]
                    .value
                    ? -1
                    : tableContent[i].dateArray[j].shiftEnd,
              });
            }
          }
        }
      }
      updated.push({ ...tableContent[i], dateArray: dateArr });
    }

    setTableContent(updated);
    setBool2(false);
  }

  function onSeatChangeData(seatId) {
    setFromSeatId(seatId);
  }

  const getTimeDiff = (start, end, type) => {
    if (start && end && start != '' && end != '')
      return moment
        .unix(end)
        .startOf(type)
        .diff(moment.unix(start).startOf(type), type);
    return 0;
  };

  function onSeatChange(seatId, index, user, column, target) {
    resetTime = false;
    let authToken = JSON.parse(localStorage.getItem('headData'))
    const params = [
      {
        userId: user.userId,
        userName: user.userName,
        seatId: seatId,
        spoc_email: user.spoc_email,
        spoc_name: user.spoc_name,
        spoc_id: UserObj.rec_id,
        dateArray: [
          {
            date: user.dateArray[column].date,
            shiftStart: user.dateArray[column].shiftStart,
            shiftEnd: user.dateArray[column].shiftEnd,
            isdisabled: user.dateArray[column].isdisabled,
            createdRoster: user.dateArray[column].createdRoster,
          },
        ],
      },
    ];
    axios
      .post(
        `${process.env.REACT_APP_API_URL}roster/insertRosterDataArrayNEW/${UserObj.company_id
        }/${selectedDepartment}`,
        params, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      }
      )
      .then(response => {
        if (response.status === 200) {
          const updatedArray = [...tableContent];
          tableContent[index].dateArray[column].isdisabled = true;
          setTableContent(updatedArray);
          toast.info(response.data.message[0].message, {

            // autoClose: false,
            // closeButton: CloseToastButton,
          });
          let userIds = selectedUserList; //[14573, 16188];
          getRosterBookingData(
            UserObj.company_id,
            selectedDepartment,
            selectedLocation,
            endDate,
            startDate,
            userIds,
          );
        } else {
          toast.error(response.data.message[0].message, {

            // autoClose: false,
            // closeButton: CloseToastButton,
          });
        }
      });

    // setFromSeatId(seatId);
  }

  function onCheckBoxClicked(userId) {
    if (selectedUser.findIndex(selected => selected === userId) == -1) {
      setSelectedUser([...selectedUser, userId]);
    } else {
      setSelectedUser(selectedUser.filter(selected => selected !== userId));
    }
  }
  function onCheckAllClick() {
    if (selectedUser.length === tableContent.length) {
      setSelectedUser([]);
    } else setSelectedUser(tableContent.map(user => user.userId));
  }

  function onRosterSubmit() {
    const userData = [];
    for (let i = 0; i < selectedUser.length; i++) {
      for (let j = 0; j < tableContent.length; j++) {
        if (tableContent[j].userId == selectedUser[i]) {
          userData.push(tableContent[j]);
        }
      }
    }

    const failedSeatUser = [];

    userData.forEach(element => {
      if (!element.seatId) failedSeatUser.push(element.userName.trim());
    });

    if (failedSeatUser.length > 0) {
      const names = failedSeatUser.join(', ');
      return toast.error(`Please select seat first for ${names}`, {

        // autoClose: false,
        // closeButton: CloseToastButton,
      });
    }

    const failedShiftUser = [];
    const deleteUserData = [];
    userData.forEach(element => {
      if (element.seatId) {
        let isShowError = true;

        element.dateArray.every(date => {
          if (
            date.shiftStart == null ||
            date.shiftEnd == null ||
            date.shiftStart == '' ||
            date.shiftEnd == '' ||
            date.shiftStart == -1 ||
            date.shiftEnd == -1 ||
            date.shiftStart == -2 ||
            date.shiftEnd == -2
          ) {
            isShowError = true;
            return true;
          } else {
            isShowError = false;
            return false;
          }
        });

        if (isShowError) {
          failedShiftUser.push(element.userName.trim());
          deleteUserData.push(element.userId);
        }
      }
    });

    if (failedShiftUser.length > 0) {
      const names = failedShiftUser.join(', ');
      toast.error(
        `Please select atleast one shift start and shift end time for ${names}`,
        {

          // autoClose: false,
          // closeButton: CloseToastButton,
        },
      );
    }

    const filterData = userData.filter(
      item => !deleteUserData.includes(item.userId),
    );

    if (filterData.length > 0) {
      postSeatBookingData(UserObj.company_id, selectedDepartment, filterData);
      setSelectedUser([]);
    }
  }

  function onCheckSeatAvailability(user, copyData) {
    const userData = [];
    for (let i = 0; i < tableContent.length; i++) {
      if (tableContent[i].userId == user.userId) {
        userData.push(tableContent[i]);
      }
    }

    const failedShiftUser = [];
    const deleteUserData = [];
    userData.forEach(element => {
      let isShowError = true;
      element.dateArray.every(date => {
        if (
          date.shiftStart == null ||
          date.shiftEnd == null ||
          date.shiftStart == '' ||
          date.shiftEnd == '' ||
          date.shiftStart == -1 ||
          date.shiftEnd == -1 ||
          date.shiftStart == -2 ||
          date.shiftEnd == -2
        ) {
          isShowError = true;
          return true;
        } else {
          isShowError = false;
          return false;
        }
      });

      if (isShowError) {
        deleteUserData.push(element.userId);
      }
    });

    if (failedShiftUser.length > 0) {
      const names = failedShiftUser.join(', ');
      toast.error(
        `Please select atleast one shift start and shift end time for ${names}`,
        {

          // autoClose: false,
          // closeButton: CloseToastButton,
        },
      );
    }

    const filterData = userData.filter(
      item => !deleteUserData.includes(item.userId),
    );

    if (filterData.length > 0) {
      const paramData = {
        seatIdArr: seatData,
        userDataArr: [copyData],
      };
      postSeatBookingDataNew(paramData);
    }

    // const startDateString = moment(startDate)
    //   .format('YYYY-MM-DD')
    //   .toString();
    // const endDateString = moment(endDate)
    //   .format('YYYY-MM-DD')
    //   .toString();

    // let userIds = selectedUserList;
    // getRosterBookingData(
    //   UserObj.company_id,
    //   selectedDepartment,
    //   selectedLocation,
    //   endDateString,
    //   startDateString,
    //   userIds
    // );
  }

  function copySubmit(copyStartDate, copyEndDate) {
    var end_date = moment(
      moment(copyStartDate, 'YYYY-MM-DD').add(5, 'days'),
    ).format('YYYY-MM-DD');
    var copy_start_date = moment(
      moment(end_date, 'YYYY-MM-DD').add(1, 'days'),
    ).format('YYYY-MM-DD');
    setStartDate(copyStartDate);
    setEndDate(copyEndDate);
    setCopyStartDate(copy_start_date);
    setCopyEndDate(
      moment(moment(copy_start_date, 'YYYY-MM-DD').add(5, 'days')).format(
        'YYYY-MM-DD',
      ),
    );
    const userData1 = [];
    for (let i = 0; i < selectedUser.length; i++) {
      for (let j = 0; j < tableContent.length; j++) {
        if (tableContent[j].userId == selectedUser[i]) {
          userData1.push(tableContent[j]);
        }
      }
    }

    // setSelectedUser([]);
    let tableCol = [];
    for (let j = 0; j < userData.length; j++) {
      tableCol.push({
        userId: userData[j].rec_id,
        userName: userData[j].name,
        seatId: null,
        dateArray: [],
      });
      const dateArr = [];
      for (
        let i = moment(copyStartDate);
        moment(i).isSameOrBefore(copyEndDate);
        i = i.add(1, 'd')
      ) {
        dateArr.push({
          date: i.format('YYYY-MM-DD').toString(),
          shiftStart: weekOff[moment(i).day()].value ? -1 : null,
          shiftEnd: weekOff[moment(i).day()].value ? -1 : null,
          isdisabled: moment(i).isSameOrBefore(moment()),
          createdRoster: true,
        });
      }
      tableCol[j].dateArray = dateArr;
    }
    for (let i = 0; i < userData1.length; i++) {
      var existingArrayUser = userData1[i].dateArray;
      var length = existingArrayUser.length;
      const updatedRosterBooking = tableCol[i];
      var copyexistingArrayUser = updatedRosterBooking.dateArray;
      if (copyexistingArrayUser.length < existingArrayUser.length) {
        length = copyexistingArrayUser.length;
      } else if (existingArrayUser.length < copyexistingArrayUser.length) {
        length = existingArrayUser.length;
      }
      for (let k = 0; k < length; k++) {
        copyexistingArrayUser[k].shiftStart = existingArrayUser[k].shiftStart;
        copyexistingArrayUser[k].shiftEnd = existingArrayUser[k].shiftEnd;
      }
      var addBothData = [...existingArrayUser, ...copyexistingArrayUser];
      userData1[i].dateArray = addBothData;
    }
    postSeatBookingData(UserObj.company_id, selectedDepartment, userData1);
    setTimeout(function () {
      onDepartmentSubmit(copyStartDate, copyEndDate);
    }, 300);
  }

  function onStartShiftChange(userIndex, dateIndex, shiftId) {
    let updatedTableConent = [...tableContent];

    if (shiftId == -1 || shiftId == -2) {
      updatedTableConent[userIndex].dateArray[dateIndex].shiftStart = Number(
        shiftId,
      );

      updatedTableConent[userIndex].dateArray[dateIndex].shiftEnd = Number(
        shiftId,
      );
    } else
      updatedTableConent[userIndex].dateArray[dateIndex].shiftStart = shiftId;

    setTableContent(updatedTableConent);
  }

  function onEndShiftChange(userIndex, dateIndex, shiftId) {
    let dateArr = [];
    let dataCopy;
    let updatedTableConent = [...tableContent];

    if (shiftId == -1 || shiftId == -2) {
      updatedTableConent[userIndex].dateArray[dateIndex].shiftStart = Number(
        shiftId,
      );
      updatedTableConent[userIndex].dateArray[dateIndex].shiftEnd = Number(
        shiftId,
      );
      dateArr.push(updatedTableConent[userIndex].dateArray[dateIndex]);
      dataCopy = JSON.parse(JSON.stringify(updatedTableConent[userIndex]));
      dataCopy.dateArray = dateArr;
    } else {
      updatedTableConent[userIndex].dateArray[dateIndex].shiftEnd = shiftId;
      updatedTableConent[userIndex].dateArray[dateIndex].seat_id = null;
      updatedTableConent[userIndex].dateArray[dateIndex].seat_title = null;
      dateArr.push(updatedTableConent[userIndex].dateArray[dateIndex]);
      dataCopy = JSON.parse(JSON.stringify(updatedTableConent[userIndex]));
      dataCopy.dateArray = dateArr;
    }
    onCheckSeatAvailability(updatedTableConent[userIndex], dataCopy);
  }

  function onAutoAssignSeat() {
    mixpanel.track('Roster Auto Assign', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Auto Assign',
    });

    var tableContentArray = JSON.parse(JSON.stringify(tableContent));

    tableContentArray.forEach(userDetails => {
      let filterDateArray = userDetails.dateArray.filter(
        item => item.shiftStart != null || item.shiftEnd != null,
      );
      userDetails.dateArray = filterDateArray;
    });

    const paramData = {
      seatIdArr: seatData,
      userDataArr: tableContentArray,
    };
    postAutoAssign(
      selectedDepartment,
      fromSeatId,
      UserObj.email,
      UserObj.fname + ' ' + UserObj.lname,
      UserObj.rec_id,
      paramData,
    );
    setFromSeatId(0);
  }

  function OnSubmitClick() {
    const startDateString = moment(startDate)
      .format('YYYY-MM-DD')
      .toString();
    const endDateString = moment(endDate)
      .format('YYYY-MM-DD')
      .toString();

    let userIds = selectedUserList; //[14573, 16188];
    getRosterBookingData(
      UserObj.company_id,
      selectedDepartment,
      selectedLocation,
      endDateString,
      startDateString,
      userIds,
    );
    setBool2(true);
  }

  function updateTableContent(tableCol) {
    const updatedRosterBooking = [...tableCol];
    if (rosterBookingData.length > 0 && tableCol.length > 0) {
      for (var i = 0; i < rosterBookingData.length; i++) {
        const isPresent = updatedRosterBooking.findIndex(
          selected => selected.userId === rosterBookingData[i].user_id,
        );
        if (isPresent === -1) {
          updatedRosterBooking.push({
            userId: rosterBookingData[i].user_id,
            userName: rosterBookingData[i].username,
            seatId: rosterBookingData[i].seat_id,
            dateArray: rosterBookingData[i].dateArray.map(date => ({
              ...date,
              shiftStart: date.shift_start_id,
              shiftEnd: date.shift_end_id,
              seatId: rosterBookingData[i].seat_id,
              date: date.shift_date,
              shift_start_time: date.shift_start_time,
              shift_end_time: date.shift_end_time,
              createdRoster: true,
            })),
          });
        } else {
          updatedRosterBooking[isPresent].seatId = rosterBookingData[i].seat_id;

          for (
            let k = 0;
            k < updatedRosterBooking[isPresent].dateArray.length;
            k++
          ) {
            for (let j = 0; j < rosterBookingData[i].dateArray.length; j++) {
              if (
                moment(rosterBookingData[i].dateArray[j].shift_date).isSame(
                  moment(updatedRosterBooking[isPresent].dateArray[k].date),
                )
              ) {
                updatedRosterBooking[isPresent].dateArray[k].shiftStart =
                  rosterBookingData[i].dateArray[j].shift_start_id;
                updatedRosterBooking[isPresent].dateArray[k].shiftEnd =
                  rosterBookingData[i].dateArray[j].shift_end_id;
                updatedRosterBooking[isPresent].dateArray[k].shift_start_time =
                  rosterBookingData[i].dateArray[j].shift_start_time;
                updatedRosterBooking[isPresent].dateArray[k].shift_end_time =
                  rosterBookingData[i].dateArray[j].shift_end_time;
                updatedRosterBooking[isPresent].dateArray[k].seatId =
                  rosterBookingData[i].dateArray[j].seat_id;
                updatedRosterBooking[isPresent].dateArray[
                  k
                ].seat_title = getTitle(
                  rosterBookingData[i].dateArray[j].seat_id,
                );
                updatedRosterBooking[isPresent].dateArray[
                  k
                ].createdRoster = true;
                updatedRosterBooking[isPresent].dateArray[k].isdisabled = true;
              }
            }
          }
        }
      }
    }

    setTableContent([...updatedRosterBooking]);
  }

  function deleteData(user, row) {
    mixpanel.track('Roster Cancel for Employee', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Cancel',
    });
    const dateArray = [];
    user.dateArray.map(res => {
      dateArray.push({
        date: res.date,
        shiftStart: res.shiftStart,
        shiftEnd: res.shiftEnd,
      });
    });

    const params = {
      userId: user.userId,
      userName: user.userName,
      userEmail: user.userEmail,
      spoc_id: UserObj.rec_id,
      dateArray: dateArray,
    };
    let authToken = JSON.parse(localStorage.getItem('headData'))
    axios
      .post(` ${process.env.REACT_APP_API_URL}roster/deleteBooking`, params, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      })
      .then(response => {
        if (response.status === 200) {
          tableContent[row].dateArray.map(e => {
            if (e.shiftStart != null) {
              e.shiftStart = null;
            }
            if (e.shiftEnd != null) {
              e.shiftEnd = null;
            }
            if (e.seat_title != null) {
              e.seat_title = null;
            }
          });
          if (response.data.statusCode != 200) {
            toast.dark(response.data.message, {

              // autoClose: false,
              // closeButton: CloseToastButton,
            });
          } else {
            toast.error(response.data.message, {

              // autoClose: false,
              // closeButton: CloseToastButton,
            });
          }
        }
        let userIds = selectedUserList; //[14573, 16188];
        getRosterBookingData(
          UserObj.company_id,
          selectedDepartment,
          selectedLocation,
          endDate,
          startDate,
          userIds,
        );
      });
  }

  function deleteBlock(user, index, column) {
    mixpanel.track('Roster Cancel Individual Day', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Cancel',
    });
    const params = {
      userId: user.userId,
      userName: user.userName,
      userEmail: user.userEmail,
      spoc_id: UserObj.rec_id,
      dateArray: [
        {
          date: user.dateArray[column].date,
          shiftStart: user.dateArray[column].shiftStart,
          shiftEnd: user.dateArray[column].shiftEnd,
          isdisabled: user.dateArray[column].isdisabled,
          createdRoster: user.dateArray[column].createdRoster,
        },
      ],
    };
    let authToken = JSON.parse(localStorage.getItem('headData'))
    axios
      .post(` ${process.env.REACT_APP_API_URL}roster/deleteBooking`, params, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      })
      .then(response => {
        if (response.status === 200) {
          tableContent[index].dateArray.map(e => {
            if (e.shiftStart != null) {
              e.shiftStart = null;
            }
            if (e.shiftEnd != null) {
              e.shiftEnd = null;
            }
            if (e.seat_title != null) {
              e.seat_title = null;
            }
          });
          if (response.data.statusCode != 200) {
            toast.dark(response.data.message, {

              // autoClose: false,
              // closeButton: CloseToastButton,
            });
          } else {
            toast.error(response.data.message, {

              // autoClose: false,
              // closeButton: CloseToastButton,
            });
          }

          let userIds = selectedUserList;
          getRosterBookingData(
            UserObj.company_id,
            selectedDepartment,
            selectedLocation,
            endDate,
            startDate,
            userIds,
          );
          // setTimeout(() => {
          //   onDepartmentSubmit(startDate, endDate);
          //   onUserListChange(selectedUserListArr);
          // }, 5000);
        }
      });
  }

  const handleLocation = selected => {
    setCurrentSelectedLocation(selected)
    setSelectedLocation(selected.id);
    setDepartmentOption([]);
    setSelectedDepartment(null)
    setCurrentSelectedDepartment(null)
    getDepDataByLocation(selected.id);
  };


const handleDepartment = (selected) => {
  if (!selected) {
    setCurrentSelectedDepartment(null);
    setSelectedDepartment(null);
    return;
  }

  setCurrentSelectedDepartment(selected);
  setSelectedDepartment(selected.id);   // ✅ USE id, NOT value
};



  const getDepDataByLocation = loc_id => {
    let authToken = JSON.parse(localStorage.getItem('headData'))

    axios
      .get(
        `${process.env.REACT_APP_API_URL}department/getActiveDepartment/${UserObj.company_id
        }/${UserObj.rec_id}/${loc_id}`, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      }
      )

      .then(response => {
        if (response.data && response.data.status == 'success') {
          let deptList = []
          for (let i = 0; i < response.data.data.activeDepartment.length; i++) {
            deptList.push({
              label:
                response.data.data.activeDepartment[i].dept_name,
              value:
                response.data.data.activeDepartment[i].dept_name,
              id: response.data.data.activeDepartment[i].id,
              dept_name:
                response.data.data.activeDepartment[i].dept_name,
              company_id:
                response.data.data.activeDepartment[i].company_id,
              createdat:
                response.data.data.activeDepartment[i].createdat,
              modifiedat:
                response.data.data.activeDepartment[i].modifiedat,
            });
          }

          setDepartmentOption(deptList);
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });
  };

  useEffect(() => {
    let authToken = JSON.parse(localStorage.getItem('headData'))

    const params = {
      params: { spoc: UserObj.rec_id, client: UserObj.company_id },
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    };
    axios
      .get(
        `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
        params,
      )
      .then(res => {
        if (res.data.status == 'success') {
          let list = [];
          for (let i = 0; i < res.data.data.length; i++) {
            list.push({
              label: res.data.data[i].location_name,
              value: res.data.data[i].location_name,
              id: res.data.data[i].rec_id,
            });
          }
          setLocationOption(list);
        }
      });
  }, []);

  function onDeleteData() {
    let authToken = JSON.parse(localStorage.getItem('headData'))
    mixpanel.track('Roster Cancel All', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Cancel All',
    });
    axios
      .post(
        ` ${process.env.REACT_APP_API_URL}roster/deleteAllBooking`,
        tableContent, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      }
      )
      .then(response => {
        if (response.data.status === 'success') {
          tableContent.forEach(element => {
            element.dateArray.map(e => {
              if (e.shiftStart != null) {
                e.shiftStart = null;
              }
              if (e.shiftEnd != null) {
                e.shiftEnd = null;
              }
              if (e.seat_title != null) {
                e.seat_title = null;
              }
            });
          });

          if (response.data.message.length > 0) {
            if (Array.isArray(response.data.message)) {
              response.data.message.forEach(message => {
                if (response.data.statusCode != 200) {
                  toast.dark(message, {

                  });
                } else {
                  toast.error(message, {

                  });
                }
              });
            } else {
              toast.error(response.data.message, {

              });
            }
          }
        }

        let userIds = selectedUserList; //[14573, 16188];
        getRosterBookingData(
          UserObj.company_id,
          selectedDepartment,
          selectedLocation,
          endDate,
          startDate,
          userIds,
        );
      });
  }

  function resetData(index) {
    const user = tableContent[index];
    const updatedData = user.dateArray.map(date => {
      if (date.shiftStart != null) {
        return {
          createdRoster: date.createdRoster,
          date: date.date,
          isdisabled: date.isdisabled,
          shiftEnd: null,
          shiftStart: null,
        };
      } else {
        return {
          createdRoster: date.createdRoster,
          date: date.date,
          isdisabled: date.isdisabled,
          shiftEnd: date.shiftEnd,
          shiftStart: date.shiftStart,
        };
      }
    });
    tableContent[index].dateArray = updatedData;
    resetUser(tableContent);
  }

  function isSeatDisable(shiftStart, shiftEnd) {
    if (
      shiftStart === null ||
      shiftEnd === null ||
      shiftStart === -1 ||
      shiftEnd === -1 ||
      shiftStart === -2 ||
      shiftEnd === -2
    ) {
      return true;
    }
    return false;
  }

  function isShiftStartDisable(shiftStart) {
    return shiftStart == null ? false : true;
  }

  function isShiftEndDisable(shiftEnd) {
    return shiftEnd == null ? false : true;
  }

  function editBlock(user, index, dateIndex) {
    mixpanel.track('Roster Edit Individual Day', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Edit',
    });
    resetTime = false;
    const updatedArray = [...tableContent];
    tableContent[index].dateArray[dateIndex].isdisabled = false;
    tableContent[index].spoc_id = UserObj.rec_id;
    setTableContent(updatedArray);
    let getShiftEnd = tableContent[index].dateArray[dateIndex].shiftEnd;
    if (shiftEndData.length == 1 && getShiftEnd != null) {
      onEndShiftChange(index, dateIndex, getShiftEnd);
    }
  }

  function resetBlock(index, dateIndex) {
    resetTime = true;
    let updatedTableConent = [...tableContent];
    updatedTableConent[index].dateArray[dateIndex].shiftStart = null;
    updatedTableConent[index].dateArray[dateIndex].shiftEnd = null;
    updatedTableConent[index].dateArray[dateIndex].seat_id = null;
    updatedTableConent[index].dateArray[dateIndex].seat_title = null;
    setTableContent(updatedTableConent);
  }

  function btnClick() {
    mixpanel.track('Rostering Page View', {
      PageName: 'Roster',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Roster',
    });
  }

  let serviceAccess = true;
  const serviceAccessId = 12;
  if (accessServiceLists.length > 0) {
    let serviceAccessobject = {};
    accessServiceLists.map(e => {
      if (e.id == serviceAccessId) serviceAccessobject = e;
    });
    serviceAccess = false;
    if (serviceAccessobject) serviceAccess = serviceAccessobject.service_access;
  }


  const shiftStartOptions =
    shiftStartData && shiftStartData.length > 0
      ? shiftStartData.map(item => ({
        value: item.shift_id,
        label: item.shift_time,
      }))
      : [];

  const shiftEndOptions =
    shiftEndData && shiftEndData.length > 0
      ? shiftEndData.map(item => ({
        value: item.shift_id,
        label: item.shift_time,
      }))
      : [];


  const seatOptions =
    departmentSeat && departmentSeat.length > 0
      ? departmentSeat.map(seat => ({
        value: seat.seat_id,
        label: seat.name,
      }))
      : [];


// Replicate Modal State 
const [showCopyModal, setShowCopyModal] = useState(false);      


  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />


        <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
          {serviceAccess === true && loaderServiceAccess == false ? (
            <>
              
              <SwModal
                show={showCopyModal}
                onClose={() => setShowCopyModal(false)}
                title="Select Date Range"
                className="sw-default-modal"
                footer={
                  <div className="d-flex justify-content-end gap-2">
                    <SwButton
                      variant="dark-outline"
                      size="sm"
                      onClick={() => setShowCopyModal(false)}
                    >
                      Close
                    </SwButton>

                    <SwButton
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        copySubmit(copyStartDate, copyEndDate);
                        setShowCopyModal(false);
                      }}
                    >
                      Submit
                    </SwButton>
                  </div>
                }
              >
                

                <div className='row mb-5 mt-4'>
                  {/* START DATE */}
                  <div className="col-md-6">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">Start Date</label>
                      <AntDDatePicker
                        type="single"
                        placeholder="Start Date"
                        value={copyStartDate ? dayjs(copyStartDate) : null}
                        allowClear={false}
                        disabledDate={(current) =>
                          current && current < dayjs().add(1, "day").startOf("day")
                        }
                        onChange={(date) =>
                          copyStartDate2({
                            target: {
                              value: date ? date.format("YYYY-MM-DD") : "",
                            },
                          })
                        }
                      />
                    </div>
                  </div>

                  {/* END DATE */}
                  <div className="col-md-6">
                    <div className="SwFormGroup">
                      <label className="SwFormLabel">End Date</label>
                      <AntDDatePicker
                        type="single"
                        placeholder="End Date"
                        value={copyEndDate ? dayjs(copyEndDate) : null}
                        allowClear={false}
                        disabledDate={(current) =>
                          current &&
                          copyStartDate &&
                          current > dayjs(copyStartDate).add(5, "day").endOf("day")
                        }
                        onChange={(date) =>
                          copyEndDate2({
                            target: {
                              value: date ? date.format("YYYY-MM-DD") : "",
                            },
                          })
                        }
                      />
                    </div>
                  </div>

                </div>
              </SwModal>


              <div className="PageContent">
                <div className="row pb-3">
                  <div className="col-md-6 ">
                    
                    <div className='SwHeading'>
                      <h2>Seat Planning</h2>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="VisualizeDatas p-3 ">

                      <div className='SwSubHeading Hv2'>
                        <h4>Visualize Datas</h4>
                      </div>

                      <div className="row">

                        <div className="col-md-3">
                          <div className="SwFormGroup">
                            <div className='SwFormLabel'>Location</div>
                            <SwSelect
                              id="seat-planning-location-select"
                              onChange={handleLocation}
                              value={currentSelectedLocation}
                              options={locationOption}
                              isClearable={false}
                            />
                          </div>
                        </div>
                        
                          <div className="col-md-2">
                            <div className="SwFormGroup">
                              <div className='SwFormLabel'>Start Date</div>
                              <AntDDatePicker
                                type="single"
                                placeholder="Start Date"
                                value={startDate ? dayjs(startDate) : null}
                                allowClear={false}
                                onChange={(date) =>
                                  onStartDateChange({
                                    target: {
                                      value: date ? date.format("YYYY-MM-DD") : "",
                                    },
                                  })
                                }
                              />
                            </div>
                          </div>
                        
                        
                          <div className="col-md-2">
                            <div className="SwFormGroup">
                              <div className='SwFormLabel'>End Date</div>
                              <AntDDatePicker
                                type="single"
                                placeholder="End Date"
                                value={endDate ? dayjs(endDate) : null}
                                allowClear={false}
                                disabledDate={(current) =>
                                  current &&
                                  startDate &&
                                  current > dayjs(startDate).add(1, "month").endOf("day")
                                }
                                onChange={(date) =>
                                  onEndDateChange({
                                    target: {
                                      value: date ? date.format("YYYY-MM-DD") : "",
                                    },
                                  })
                                }
                              />
                            </div>
                          </div>
                        
                        
                          <div className="col-md-3">
                            <div className="SwFormGroup">
                              <div className="SwFormLabel">Department</div>
                              <SwSelect
                                id="seat-planning-department-select"
                                onChange={handleDepartment}
                                value={currentSelectedDepartment}
                                options={departmentOption}
                                isClearable={false}
                              />  
                            </div>
                          </div>
                        
                        <div className="col-md-2">
                          <div className="SwFormGroup">
                            <label className="SwFormLabel invisible">No Label</label>
                            <SwButton
                              variant="dark"
                              size="sm"
                              onClick={() => {
                                onDepartmentSubmit(startDate, endDate);
                                setSelectedUserList([]);
                              }}
                              disabled={
                                selectedDepartment == null ||
                                selectedLocation == null
                              }
                            >
                              View
                            </SwButton>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
                <div className="AssignRoster p-3 ">
                  <div className='SwSubHeading Hv2'>
                    <h4>Assign Roster</h4>
                  </div>
                  <DualListBox
                    canFilter
                    options={options}
                    className="RosterDual_List"
                    preserveSelectOrder
                    showOrderButtons
                    selected={selectedUserList}
                    onChange={onUserListChange}
                  />
                </div>
                <br />
                <div className='text-end'>
                  <SwButton
                    variant="dark"
                    size="sm"
                    onClick={OnSubmitClick}
                    disabled={selectedUserList.length == 0 || seatData.length == 0}
                  >
                    Proceed
                  </SwButton>
                </div>{' '}
                <br />
                {seatBookingLoading ||
                  (userDataLoading ||
                    rosterDataLoading ||
                    availableSeatDataLoading ||
                    assignSeatLoading) ? (
                  <div className="spinner-border big-spinner" />
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <div className="DeployShift_Container">
                        <div className="DeployShift p-3 mt-0 ">
                          <div className='SwSubHeading Hv2'>
                            <h4>Deploy Shift</h4>
                          </div>
                          <div className="row">
                            <div className="col-xs-6 col-lg-2 col-md-6">
                                <div className='SwFormGroup'>
                                  <div className="SwFormLabel">Shift Start </div>
                                  <SwSelect
                                    id="deploy-shift-start-select"
                                    placeholder="Select"
                                    options={shiftStartOptions}
                                    value={
                                      deployShiftStart
                                        ? shiftStartOptions.find(
                                          option => option.value === deployShiftStart
                                        )
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      setDeployShiftStart(selectedOption ? selectedOption.value : null)
                                    }
                                  />
                                </div>
                            </div>
                            <div className="col-xs-6 col-lg-2 col-md-6">
                                <div className='SwFormGroup'>
                                  <div className="SwFormLabel">Shift End </div>
                                  <SwSelect
                                    id="deploy-shift-end-select"
                                    placeholder="Select"
                                    options={shiftEndOptions}
                                    value={
                                      deployShiftEnd
                                        ? shiftEndOptions.find(
                                          option => option.value === deployShiftEnd
                                        )
                                        : null
                                    }
                                    onChange={(selectedOption) =>
                                      setDeployShiftEnd(selectedOption ? selectedOption.value : null)
                                    }
                                  />
                                </div>
                            </div>

                            <div className="col-xs-6 col-lg-8 ">
                                <div className='SwFormLabel'>Weekly Off </div>
                                <div className="weekly-off-strip me-2">

                                  {weekOff.map((day, index) => (

                                    <SwCheckbox
                                      id={`weekoff-${day.day}`}
                                      name="weekOff"
                                      label={day.day}
                                      checked={day.value}
                                      onChange={() => onWeekOffChange(day.day)}
                                      inline
                                    />

                                  ))}

                                </div>
                                <SwButton
                                  variant="dark"
                                  size="sm"
                                  className='me-2'
                                  disabled={
                                    deployShiftStart == null ||
                                    deployShiftEnd == null ||
                                    seatData.length == 0
                                  }
                                  onClick={onDeployShiftApply}
                                >
                                  Apply
                                </SwButton>
                                
                                <SwButton
                                  variant='dark-outline'
                                  size="sm"
                                  disabled={
                                    selectedUser.length < 1 || seatData.length == 0
                                  }
                                  onClick={() => setShowCopyModal(true)}
                                >
                                  Replicate
                                </SwButton>
                            </div>
                          </div>
                        </div>

                        <div className="tableHeaderResponse tableHeaderRoster px-3 border-0 m-0">
                          <div className="row pt-3">
                            <div className="col-lg-4">
                              <div className="DepMasterNotice d-inline-block m-0 p-2">
                                <ul>
                                  <li>24 Hrs in advance</li>
                                  <li>30 days max validation</li>
                                </ul>
                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div className="d-flex justify-content-end gap-2">

                                <SwSelect
                                  id="seat-number-select"
                                  placeholder="Select Seat No."
                                  options={seatOptions}
                                  value={seatOptions.find(opt => opt.value === fromSeatId) || null}
                                  onChange={(selectedOption) =>
                                    onSeatChangeData(selectedOption ? selectedOption.value : null)
                                  }
                                />

                                
                                <SwButton
                                  size="sm"
                                  variant="dark"
                                  onClick={onAutoAssignSeat}
                                  disabled={
                                    selectedUserList.length == 0 ||
                                    (deployShiftStart == null ||
                                      deployShiftEnd == null) ||
                                    bool2 ||
                                    seatData.length == 0
                                  }
                                >
                                  Auto Assign
                                </SwButton>
                                
                                <SwButton
                                  variant='dark-outline'
                                  size="sm"
                                  onClick={onDeleteData}
                                  disabled={
                                    selectedUserList.length == 0 ||
                                    // (deployShiftStart == null ||
                                    //   deployShiftEnd == null) ||
                                    seatData.length == 0
                                  }
                                >
                                  Cancel All
                                </SwButton>
                              </div>
                            </div>
                          </div>
                          <div className="commonTable roster_tbl_wrapper">
                            <table className="table customeTable roster_tbl mb-0">
                              <thead>
                                <tr>
                                  <th>
                                    {' '}
                                    <div className="px-3">Employee</div>
                                  </th>
                                  <th>&nbsp;</th>

                                  {loopDate()}
                                  <th>&nbsp;</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tableContent &&
                                  tableContent.map((user, index) => (
                                    <>
                                      <tr>
                                        <td className="EmpNameRstr">
                                          <div className="px-3">
                                            {user.userName}
                                          </div>
                                        </td>

                                        <td>
                                          <div className="RosterColumn_Label">
                                            <span>Shift Start</span>
                                            <span>Shift End</span>
                                            <span>Seat</span>
                                          </div>
                                        </td>
                                        {user.dateArray.map((col, dateindex) => (
                                          <>
                                            <td>
                                              <div className="RosterColumn d-flex">
                                                <div
                                                  className={`RosterColumn_Select ${
                                                    col.shiftStart &&
                                                    col.shiftEnd &&
                                                    col.seat_title &&
                                                    col.shiftStart != -1 &&
                                                    col.shiftStart != -2
                                                      ? "RosterColumn_Selected"
                                                      : ""
                                                  }`}
                                                >
                                                  <div className="d-flex align-items-start">
                                                    <select
                                                      className="form-control form-control-sm"
                                                      // value={
                                                      //   col.shiftStart
                                                      //     ? col.shiftStart
                                                      //     : ''
                                                      // }
                                                      // style={{
                                                      //   borderColor:
                                                      //     col.shiftStart &&
                                                      //     col.shiftEnd &&
                                                      //     col.seat_title &&
                                                      //     col.shiftStart != -1 &&
                                                      //     col.shiftStart != -2
                                                      //       ? 'red'
                                                      //       : 'green',
                                                      // }}
                                                      // style={{
                                                      //   backgroundColor:
                                                      //     col.shiftStart &&
                                                      //     col.shiftEnd &&
                                                      //     col.seat_title &&
                                                      //     col.shiftStart != -1 &&
                                                      //     col.shiftStart != -2
                                                      //       ? '#dbeafa'
                                                      //       : '#f6f4f5',
                                                      // }}
                                                      // style={{
                                                      //   backgroundColor:
                                                      //     col.shiftStart &&
                                                      //     col.shiftEnd &&
                                                      //     col.seat_title &&
                                                      //     col.shiftStart != -1 &&
                                                      //     col.shiftStart != -2
                                                      //       ? '#dbeafa'
                                                      //       : col.shiftStart == -1 ||
                                                      //         col.shiftStart == -2
                                                      //       ? '#f5f6f8'
                                                      //       : '#f6f4f5',
                                                      // }}
                                                      value={(() => {
                                                        if (
                                                          col.shiftStart &&
                                                          !resetTime
                                                        ) {
                                                          return col.shiftStart;
                                                        } else {
                                                          return col.shiftStart
                                                            ? col.shiftStart
                                                            : '';
                                                        }
                                                      })()}
                                                      disabled={
                                                        moment(col.date) <
                                                        moment().subtract(
                                                          1,
                                                          'days',
                                                        ) ||
                                                        (col.isdisabled &&
                                                          col.shiftStart) ||
                                                        (!todayBookingAccessUserEmail.includes(
                                                          user.spoc_email?.toLowerCase(),
                                                        ) &&
                                                          moment(col.date).format(
                                                            'YYYY-MM-DD',
                                                          ) ==
                                                          moment().format(
                                                            'YYYY-MM-DD',
                                                          ))
                                                      }
                                                      onChange={e =>
                                                        onStartShiftChange(
                                                          index,
                                                          dateindex,
                                                          e.target.value,
                                                        )
                                                      }
                                                    >
                                                      <option value={null}>
                                                        {moment(col.date) <
                                                          moment().subtract(1, 'days')
                                                          ? 'N/A'
                                                          : ''}
                                                      </option>
                                                      {shiftStartData &&
                                                        shiftStartData.length > 0 &&
                                                        createShiftOption(
                                                          shiftStartData,
                                                          !todayBookingAccessUserEmail.includes(
                                                            user.spoc_email?.toLowerCase(),
                                                          )
                                                            ? true
                                                            : false,
                                                          col.date,
                                                        )}
                                                      <option value={-1}>
                                                        Week Off
                                                      </option>
                                                      <option value={-2}>
                                                        WFH
                                                      </option>
                                                    </select>

                                                    <div className="dropdown RosterDD">
                                                      <a
                                                        className="dropdown-toggle"
                                                        id="dropdownMenu2"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                      >
                                                        <i className="bi bi-three-dots-vertical"></i>
                                                      </a>
                                                      <div
                                                        className="dropdown-menu"
                                                        aria-labelledby="dropdownMenu2"
                                                      >
                                                        {moment(col.date) <=
                                                          moment().subtract(
                                                            1,
                                                            'days',
                                                          ) ? (
                                                          ''
                                                        ) : (
                                                          // <button
                                                          //   className="dropdown-item"
                                                          //   type="button"
                                                          //   onClick={e =>
                                                          //     editBlock(
                                                          //       user,
                                                          //       index,
                                                          //       dateindex,
                                                          //     )
                                                          //   }
                                                          //   disabled
                                                          // >
                                                          //   Edit
                                                          // </button>
                                                          <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={e =>
                                                              editBlock(
                                                                user,
                                                                index,
                                                                dateindex,
                                                              )
                                                            }
                                                          >
                                                            <i className='bi bi-pencil-fill' />
                                                            <span>Edit</span>
                                                          </button>
                                                        )}

                                                        {col.shiftStart &&
                                                          col.shiftEnd &&
                                                          col.seat_title ? (
                                                          ''
                                                        ) : (
                                                          <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={e =>
                                                              resetBlock(
                                                                index,
                                                                dateindex,
                                                              )
                                                            }
                                                          >
                                                            <i className='bi bi-arrow-counterclockwise' />
                                                            <span>Reset</span>
                                                          </button>
                                                        )}

                                                        {moment(col.date) <=
                                                          moment().subtract(
                                                            1,
                                                            'days',
                                                          ) ||
                                                          col.shiftStart == -1 ||
                                                          col.shiftEnd == -1 ||
                                                          col.shiftStart == -2 ||
                                                          col.shiftEnd == -2 ||
                                                          !col.shiftStart ||
                                                          !col.shiftEnd ||
                                                          !col.seat_title ? (
                                                          ''
                                                        ) : (
                                                          <button
                                                            className="dropdown-item"
                                                            type="button"
                                                            onClick={e =>
                                                              deleteBlock(
                                                                user,
                                                                index,
                                                                dateindex,
                                                              )
                                                            }
                                                          >
                                                            <i className='bi bi-trash-fill' />
                                                            <span>Delete</span>
                                                          </button>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <select
                                                      // value={
                                                      //   col.shiftEnd ? col.shiftEnd : ''
                                                      // }
                                                      // style={{
                                                      //   borderColor:
                                                      //     col.shiftEnd &&
                                                      //     col.shiftStart &&
                                                      //     col.seat_title &&
                                                      //     col.shiftEnd != -1 &&
                                                      //     col.shiftEnd != -2
                                                      //       ? 'red'
                                                      //       : 'green',
                                                      // }}
                                                      // style={{
                                                      //   backgroundColor:
                                                      //     col.shiftStart &&
                                                      //     col.shiftEnd &&
                                                      //     col.seat_title &&
                                                      //     col.shiftEnd != -1 &&
                                                      //     col.shiftEnd != -2
                                                      //       ? '#dbeafa'
                                                      //       : col.shiftEnd == -1 ||
                                                      //         col.shiftEnd == -2
                                                      //       ? '#f5f6f8'
                                                      //       : '#f6f4f5',
                                                      // }}
                                                      value={(() => {
                                                        if (
                                                          col.shiftEnd &&
                                                          !resetTime
                                                        ) {
                                                          return col.shiftEnd;
                                                        } else {
                                                          return col.shiftEnd
                                                            ? col.shiftEnd
                                                            : '';
                                                        }
                                                      })()}
                                                      disabled={
                                                        moment(col.date) <
                                                        moment().subtract(
                                                          1,
                                                          'days',
                                                        ) ||
                                                        (col.isdisabled &&
                                                          col.shiftEnd) ||
                                                        (!todayBookingAccessUserEmail.includes(
                                                          user.spoc_email?.toLowerCase(),
                                                        ) &&
                                                          moment(col.date).format(
                                                            'YYYY-MM-DD',
                                                          ) ==
                                                          moment().format(
                                                            'YYYY-MM-DD',
                                                          ))
                                                      }
                                                      className="form-control form-control-sm"
                                                      onChange={e =>
                                                        onEndShiftChange(
                                                          index,
                                                          dateindex,
                                                          e.target.value,
                                                        )
                                                      }
                                                    >
                                                      <option value={null}>
                                                        {moment(col.date) <
                                                          moment().subtract(1, 'days')
                                                          ? 'N/A'
                                                          : ''}
                                                      </option>
                                                      {shiftEndData &&
                                                        col.shiftStart &&
                                                        shiftEndData.length > 0 &&
                                                        createShiftOption(
                                                          shiftEndData,
                                                          false,
                                                          null,
                                                        )}
                                                      {col.shiftStart ? (
                                                        <>
                                                          <option value={-1}>
                                                            Week Off
                                                          </option>
                                                          <option value={-2}>
                                                            WFH
                                                          </option>
                                                        </>
                                                      ) : (
                                                        ''
                                                      )}
                                                    </select>
                                                  </div>
                                                  <div>
                                                    <select
                                                      disabled={
                                                        col.isdisabled ||
                                                        moment(col.date) <
                                                        moment().subtract(
                                                          1,
                                                          'days',
                                                        ) ||
                                                        (!todayBookingAccessUserEmail.includes(
                                                          user.spoc_email?.toLowerCase(),
                                                        ) &&
                                                          moment(col.date).format(
                                                            'YYYY-MM-DD',
                                                          ) ==
                                                          moment().format(
                                                            'YYYY-MM-DD',
                                                          ))
                                                      }
                                                      // value={
                                                      //   col.seat_title
                                                      //     ? col.seat_title
                                                      //     : ''
                                                      // }
                                                      // style={{
                                                      //   borderColor:
                                                      //     col.seat_title &&
                                                      //     col.shiftEnd &&
                                                      //     col.shiftStart
                                                      //       ? 'red'
                                                      //       : 'green',
                                                      // }}
                                                      // style={{
                                                      //   backgroundColor:
                                                      //     col.shiftStart &&
                                                      //     col.shiftEnd &&
                                                      //     col.seat_title &&
                                                      //     col.shiftStart != -1 &&
                                                      //     col.shiftStart != -2
                                                      //       ? '#dbeafa'
                                                      //       : '#f6f4f5',
                                                      // }}
                                                      value={(() => {
                                                        if (
                                                          col.seat_title &&
                                                          !resetTime
                                                        ) {
                                                          return col.seat_title;
                                                        } else {
                                                          return col.seat_title
                                                            ? col.seat_title
                                                            : '';
                                                        }
                                                      })()}
                                                      className="form-control form-control-sm"
                                                      onChange={e =>
                                                        onSeatChange(
                                                          e.target.value,
                                                          index,
                                                          user,
                                                          dateindex,
                                                        )
                                                      }
                                                    >
                                                      <option>
                                                        {(() => {
                                                          if (
                                                            col.seat_title &&
                                                            !resetTime
                                                          ) {
                                                            return col.seat_title;
                                                          } else {
                                                            return col.seat_title
                                                              ? col.seat_title
                                                              : '';
                                                          }
                                                        })()}
                                                        {/* {col.seat_title
                                                  ? col.seat_title
                                                  : ''} */}
                                                      </option>
                                                      {// !col.seat_title &&
                                                        availableSeatData.map(
                                                          seat_obj => (
                                                            <option
                                                              value={
                                                                seat_obj.seat_id
                                                                  ? seat_obj.seat_id
                                                                  : ''
                                                              }
                                                            >
                                                              {seat_obj.name
                                                                ? seat_obj.name
                                                                : ''}
                                                            </option>
                                                          ),
                                                        )}
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </>
                                        ))}
                                        <td>
                                          <div className="RosterColumn_CTA">
                                            <button
                                              type="button"
                                              className="btn btn-sm btn-outline-danger"
                                              onClick={e => deleteData(user, index)}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="13"
                                                height="13"
                                                fill="currentColor"
                                                className="bi bi-trash3"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                              </svg>
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : loaderServiceAccess == true ? (
            <>
              <SwLoader />
            </>
          ) : (
            <MarketingPanel />
          )}
        </Layout>
      </Layout>
    </>
  );
}



const mapStateToProps = state => {
  return state;
};
const mapActionsToProps = {
  getFilterData,
  getDepartmentList,
  getCompanySeatData,
  postSeatBookingData,
  getRosterBookingData,
  postAutoAssign,
  getDepartmentUserData,
  postSeatBookingDataNew,
  resetUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(Roster);
